export const config = {
  data() {
    return {
      columns:[
        {
          title: "合同名称",
          slot: "subject",
          align: "center",
          minWidth:140,   
        },
        {
          title: "合同编号",
          key: "sn",
          minWidth:140,
          align: "center",
          tooltip:true
        },
        {
          title: "合同类型",
          align: "center",
          minWidth:100,
          render(h, param) {
            const map = {
              '1': '新签',
              '2': '续签',
              '3': '解约',
              '4': '补签',
            }
            return <span>{map[param.row.type]||'-'}</span>
          }
        },
        {
          title: "上传用户",
          key: "createName",
          minWidth:140,
          align: "center",
          tooltip:true
        },
        {
          title: "上传时间",
          slot: "createTime",
          minWidth:140,
          align: "center",
          tooltip:true
        },
        {
          title: "开始时间",
          key: "contractBeginDate",
          align: "center",
          minWidth:140,
          tooltip:true
        },
        {
          title: "结束时间",
          key: "contractEndDate",
          align: "center",
          minWidth:140,
          render(h, params) {
            let contractEndDate = params.row.contractEndDate;
            return <span>{ contractEndDate?contractEndDate:'-' }</span>
          }
        },
        {
          title: "状态",
          slot: "status",
          align: "center",
          width: "100",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "180",
        },
      ],
    }
  },
  methods: {

  }
}
